import cn from 'classnames';
import React from 'react';

import {getLocalizedStrings} from '../../../services/localization/localizationService';
import AppButton from '../../Button/AppButton/AppButton';
import ConnectionTrackButton from '../../Button/ConnectionTrackButton/ConnectionTrackButton';
import {ErrorIcon} from '../../Icons';
import {MaxWidthContainer} from '../../Layout';

const Article = (props) => {
    const {
        titleText,
        titleTestId,
        titleKey,
        titleClassName,
        titleComponent: TitleComponent = 'h1',
        descriptionKey,
        descriptionText,
        descriptionContent,
        descriptionClassName,
        subDescription,
        children,
        error,
        icon,
        className,
        buttonsDirection = 'row',
        buttonPrimary,
        buttonSecondary,
        size,
    } = props;
    const localizedStrings = getLocalizedStrings();
    const Icon = getIcon({error});
    const title = titleText || localizedStrings[titleKey];
    const description = descriptionText || localizedStrings[descriptionKey];
    const isButtonsDirectionColumn = buttonsDirection === 'column';

    return (
        <MaxWidthContainer className={className} size={size}>
            {icon && icon}
            {Icon && <Icon className='mb-4 h-6 w-6 lg:mb-6 lg:h-8 lg:w-8' />}
            {title && (
                <TitleComponent
                    data-testid={titleTestId}
                    className={cn({'mb-0': !description && !descriptionContent}, titleClassName)}
                    dangerouslySetInnerHTML={{
                        __html: title,
                    }}
                />
            )}
            {descriptionContent && descriptionContent}
            {description && (
                <p className={descriptionClassName}>
                    <span
                        className='whitespace-pre-line'
                        dangerouslySetInnerHTML={{
                            __html: description,
                        }}
                    />
                    {subDescription && subDescription}
                </p>
            )}
            {buttonPrimary && !buttonSecondary && <Button primary {...buttonPrimary} />}
            {!buttonPrimary && buttonSecondary && <Button secondary {...buttonSecondary} />}
            {buttonPrimary && buttonSecondary && (
                <div
                    className={cn(
                        'mt-10 grid w-full grid-cols-1 gap-3',
                        isButtonsDirectionColumn ? 'justify-items-center' : 'md:grid-cols-2 md:gap-8'
                    )}
                >
                    <Button
                        primary
                        className={cn('m-0', {'md:order-1 md:min-w-0': !isButtonsDirectionColumn})}
                        {...buttonPrimary}
                    />
                    <Button
                        secondary
                        className={cn('m-0', {'md:min-w-0': !isButtonsDirectionColumn})}
                        {...buttonSecondary}
                    />
                </div>
            )}
            {children}
        </MaxWidthContainer>
    );
};

export default Article;

const Button = (props) => {
    const {textKey, text, ariaLabelKey, isConnectionTrack, ...rest} = props;
    const localizedStrings = getLocalizedStrings();
    const buttonText = textKey ? localizedStrings[textKey] : text;
    const CustomButton = isConnectionTrack ? ConnectionTrackButton : AppButton;

    return (
        <CustomButton
            button={isConnectionTrack ? AppButton : undefined}
            light
            ariaLabel={ariaLabelKey ? localizedStrings[ariaLabelKey] : undefined}
            {...rest}
        >
            {buttonText}
        </CustomButton>
    );
};

const getIcon = ({error}) => {
    if (error) {
        return ErrorIcon;
    }

    return null;
};
